import {packId} from 'common/diplomatIdUtil';
import {pushErrorToast} from 'features/notifications/redux/actions';
import {delay, call, select, race, put} from 'redux-saga/effects';
import {unhandedSagaError} from 'redux/common';

import history from 'redux/history';
import {State} from 'redux/reducer';
import {transactionsTypes} from 'redux/transactions';
import {validate} from 'redux/transactions/sagas/validate/validateSaga';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';

function* waitForOpenTransaction(id: string, objectType: DiplomatObjectTypeUnion) {
   let transaction = (yield select((state: State) => state.commonPage.data)) as IDiplomatObject;
   while (!transaction || !(transaction.id === id && transaction.objectType === objectType)) {
      transaction = (yield select((state: State) => state.commonPage.data)) as IDiplomatObject;
      yield delay(300);
   }
   return transaction as IDiplomatObject;
}

type OpenValidateTransactionAction = {
   type: string;
   payload: {
      id: string;
      objectType: DiplomatObjectTypeUnion;
   };
};
export function* openAndValidate(action: OpenValidateTransactionAction) {
   try {
      const {id, objectType} = action.payload;
      yield call(history.push, '/' + packId(objectType, id));

      const {transaction, timeout} = yield race({
         transaction: waitForOpenTransaction(id, objectType),
         tiemout: delay(7 * 1000),
      });

      if (timeout) {
         yield put(pushErrorToast());
      } else {
         const data = transaction as ITransaction;
         yield call(validate, {type: transactionsTypes.VALIDATE_TRANSACTION.SAGA, payload: {data}});
      }
   } catch (e) {
      yield call(unhandedSagaError, e as Error);
   }
}
